import styled, { css } from 'styled-components';
import Input from '../input/Input';
import { TransparentButton } from '../transparent-button/TransparentButton';
import ErrorMessage from '../error-message/ErrorMessage';
export const CustomInputTab = styled.div `
  display: flex;
  align-items: center;
  border-radius: ${({ theme, borderTopFlat, borderBottomFlat }) => `${borderTopFlat ? 0 : theme.borderRadius.mediumHigh} ${borderTopFlat ? 0 : theme.borderRadius.mediumHigh} ${borderBottomFlat ? 0 : theme.borderRadius.mediumHigh} ${borderBottomFlat ? 0 : theme.borderRadius.mediumHigh}`};
  border: 1px solid
    ${({ theme, hasError }) => hasError ? theme.colors.borders.critical : theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.default};
  transition: all 0.3s ease;
  padding-right: 1rem;
  height: 10.5rem;
  box-shadow: ${({ isFocused, theme }) => isFocused ? theme.shadows.xl : 'none'};
  position: relative;
  ${({ theme, isFocused }) => isFocused
    ? css `
          background-color: ${theme.colors.surface.buttonBackground};
          border-color: ${theme.colors.interactive.brandColor};
        `
    : css ``};

  ${({ theme }) => theme.media.mobileM `
    padding-right: 1.6rem;
  `}
  &:hover {
    .container {
      background-color: transparent !important;
    }
  }
  ${({ theme, hasError }) => {
    const backgroundColor = theme.colors.surface.hover;
    const borderCrit = theme.colors.borders.critical;
    const borderHov = theme.colors.borders.hover;
    return theme.media.laptop `
    &:hover {
      background-color: ${backgroundColor}
      border: 1px solid ${hasError
        ? borderCrit
        : borderHov}
    }
  `;
}}
`;
export const CustomInput = styled(Input) `
  border: none !important;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background: transparent;
  & input {
    background: transparent;
    font-family: ${({ theme }) => theme.fonts.primaryBold};
    ${({ isLoading }) => isLoading && 'display: none'}
  }
  &:focus {
    background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  }
  .input-placeholder {
    white-space: nowrap;
  }
  &:hover {
    background-color: transparent;
  }

  ${({ theme }) => theme.media.laptop `
    &:hover {
      border: none;
    }
  `}
  .icon-wrapper {
    position: absolute;
    top: 2.4rem;
    left: 1.6rem;
  }
`;
export const FlexContainer = styled.div `
  display: flex;
  align-items: center;
  min-width: 10rem;
`;
export const CustomTransparentButton = styled(TransparentButton) `
  margin-right: 1rem;
`;
export const CustomBalanceContainer = styled.div `
  width: max-content;
  margin-top: 0.4rem;
`;
export const CustomSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CustomErrorMessage = styled(ErrorMessage) `
  margin: 0.5rem 0 0.5rem;
`;
export const CustomCurrencyContainer = styled.div `
  position: relative;

  width: 100%;
`;
export const AnimationWrapper = styled.div `
  width: 8.7rem;
  height: 6.7rem;
  position: absolute;
  top: 1.6rem;
  left: -1rem;
`;
export const TabsWrapper = styled.div `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map